export default "/images/bedb8b7321175ff18b1ad05771ff4894.png";